import { type Components, type Theme } from "@mui/material/styles";

export const iconButton: Components<Theme>["MuiIconButton"] = {
  defaultProps: {
    size: "small",
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      ...(ownerState.variant === "withBackground" && {
        padding: "4px 8px",
        borderRadius: 8,
        backgroundColor: theme.palette.blackStates._states.selected,
      }),
    }),
  },
};
